import * as defaultImport from "@splunk/react-icons/Eye";
export * from "@splunk/react-icons/Eye";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
